export const parseIdList = (value) => {
  if (value === null || value === undefined || value === "") return [];

  if (Array.isArray(value)) {
    return value
      .map((id) => Number(id))
      .filter((id) => !Number.isNaN(id) && Number.isInteger(id));
  }

  return String(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => Number(part))
    .filter((id) => !Number.isNaN(id) && Number.isInteger(id));
};

export const collectStrictIntegerIdList = (value) => {
  if (value === null || value === undefined || value === "") {
    return { ids: [], invalidSegments: [] };
  }

  if (Array.isArray(value)) {
    const ids = [];
    const invalidSegments = [];

    value.forEach((entry) => {
      const normalizedEntry = String(entry ?? "").trim();
      if (!normalizedEntry) {
        return;
      }

      if (!/^\d+$/.test(normalizedEntry)) {
        invalidSegments.push(normalizedEntry);
        return;
      }

      ids.push(Number(normalizedEntry));
    });

    return { ids, invalidSegments };
  }

  const ids = [];
  const invalidSegments = [];

  String(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .forEach((part) => {
      if (!/^\d+$/.test(part)) {
        invalidSegments.push(part);
        return;
      }

      ids.push(Number(part));
    });

  return { ids, invalidSegments };
};

export const parsePackageIds = parseIdList;
export const parsePlatformIds = parseIdList;
